import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// ── HEADER BRAND ─────────────────────────────────────────────────────────────
// The logo in the site header. ONE destination everywhere: your own profile if
// you are signed in, the landing page if you are not.
//
// It was copy-pasted across five pages with three different behaviours — two
// did nothing at all, two went to the landing page, one to the dashboard. The
// logo is the most-clicked thing in any header, and it must not depend on which
// page you happen to be standing on.
//
// A BUTTON, not a div with onClick: the old markup used `role="button"` and
// tabIndex but had no key handler, so it was reachable by keyboard and did
// nothing when you pressed Enter.
export default function NavBrand({ className = 'dash-nav-brand' }) {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <button
      type="button"
      className={className}
      onClick={() => navigate(user ? '/dashboard' : '/')}
    >
      <img src="/images/Tunify Original logo tab.png" alt="Tunify" className="dash-nav-logo" />
      <span className="dash-nav-name">Tunify</span>
    </button>
  );
}
